import React from 'react'
import ContentfulContentMDS from '@toasttab/shared/src/components/templates/ContentfulContentMDS'
import ContentfulJsonDataObject from '@toasttab/main/src/components/templates/ContentfulJsonDataObject'

const SnowflakeRenderer = (content: any[]): React.ReactNode => {
  class ComponentErrorBoundary extends React.Component<
    { children: React.ReactNode },
    { hasError: boolean }
  > {
    constructor(props: { children: React.ReactNode }) {
      super(props)
      this.state = { hasError: false }
    }

    static getDerivedStateFromError(_: Error) {
      return { hasError: true }
    }

    render() {
      if (this.state.hasError) {
        return null // Silently handle errors in production
      }

      return this.props.children
    }
  }

  if (!Array.isArray(content)) {
    return null
  }

  let componentCounts: { [key: string]: number } = {}

  return content
    .map((item: any, index: number) => {
      if (!item || typeof item !== 'object' || !item.__typename) {
        return null
      }

      if (
        item.__typename === 'ContentfulMdsJsonDataObject' &&
        item.contentObject?.internal?.content
      ) {
        try {
          const component = JSON.parse(item.contentObject.internal.content)
          let renderedComponent: React.ReactNode = null

          const componentProps = {
            template: component.componentTemplate,
            props: component.content
          }

          renderedComponent = <ContentfulJsonDataObject data={componentProps} />

          return renderedComponent ? (
            <ComponentErrorBoundary key={index}>
              {renderedComponent}
            </ComponentErrorBoundary>
          ) : null
        } catch (error) {
          return null
        }
      } else {
        try {
          componentCounts = Object.assign(componentCounts, {
            [item.__typename]: componentCounts[item.__typename]
              ? componentCounts[item.__typename] + 1
              : 1
          })
          item.dataTestId = `${item.__typename}-${
            componentCounts[item.__typename]
          }`
          let renderedComponent: React.ReactNode = null

          renderedComponent = (
            <ContentfulContentMDS
              content={item}
              key={index}
              type={item.__typename}
            />
          )

          return renderedComponent ? (
            <ComponentErrorBoundary key={index}>
              {renderedComponent}
            </ComponentErrorBoundary>
          ) : null
        } catch (error) {
          return null
        }
      }
    })
    .filter(Boolean)
}

export default SnowflakeRenderer
